import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { BntDeliveryOptionsComponent } from './bnt.delivery-options.component';
import { BntService }                  from './bnt.service';
import { BntSettingsComponent }        from './bnt.settings.component';
import { BntStates }                   from './bnt.states';
import { SharedModule }                from '../shared/shared.module';
import { VendorsModule }               from '../vendors/vendors.module';

@NgModule({
  declarations: [
    BntDeliveryOptionsComponent,
    BntSettingsComponent
  ],
  entryComponents: [
    BntDeliveryOptionsComponent,
    BntSettingsComponent
  ],
  imports: [
    SharedModule,
    VendorsModule,

    UIRouterUpgradeModule.forChild({ states: BntStates })
  ],
  providers: [
    BntService
  ]
})
export class BntModule {}
